import { render, staticRenderFns } from "./ConfigFactory.vue?vue&type=template&id=7f156de2&scoped=true&"
import script from "./ConfigFactory.vue?vue&type=script&lang=js&"
export * from "./ConfigFactory.vue?vue&type=script&lang=js&"
import style0 from "./ConfigFactory.vue?vue&type=style&index=0&id=7f156de2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f156de2",
  null
  
)

export default component.exports